<template>
  <a-icon-sheet-card title="Recruiting.Dashboard.JobApplicationProcessTitle">
    <div class="mx-4 mt-3">
      <div class="row">
        <div
          v-for="(item, index) in data"
          :key="index"
          class="px-4 mb-3 flex-grow"
          @click="itemClicked(item)"
        >
          <div class="row">
            <div
              class="col job-application-process-dashlet-item"
              :style="getStateColor(item.jobApplicationCount)"
            >
              <div
                class="text-truncate text-uppercase text-white"
                v-text="item.text"
              />
              <div
                class="font-weight-bold text-white"
                v-text="item.jobApplicationCount"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-icon-sheet-card>
</template>

<script>
import IconSheetCard from "+/components/card/IconSheetCard";
import _ from "lodash";
import utils from "./utils/utils.js";

export default {
  components: {
    "a-icon-sheet-card": IconSheetCard
  },
  props: {
    data: { type: Array, default: () => [] }
  },
  computed: {
    maxJobApplicationCount: function() {
      const max = _.maxBy(this.data, "jobApplicationCount").jobApplicationCount;
      return max == 0 ? 1 : max;
    }
  },
  methods: {
    getStateColor(count) {
      let opacityDecimalPlace = Math.round(count / this.maxJobApplicationCount);
      if (typeof opacityDecimalPlace !== "number" || opacityDecimalPlace < 6) {
        opacityDecimalPlace = 6;
      } else if (opacityDecimalPlace > 9) {
        opacityDecimalPlace = 99;
      }

      return `background-color: rgba(92, 105, 112, 0.${opacityDecimalPlace})`;
    },
    async itemClicked(item) {
      await utils.delZSearchSession("iBM_BM");
      const route = `/main/bm?STsearchfield_SB_REFNR=OWN&combovalue_ERL_N=''&STsearchfield_statusart=${item.key}&z_suche_cookie=1`;
      this.$router.push(route);
    }
  }
};
</script>
